export default __webpack_public_path__ + "static/media/logo-dpt.7a84a6b2.png";